
import App from "./App";
import Tabs from "./tabs/Tabs";



if(document.getElementById('app')) {
    ReactDOM.render(<App />, document.getElementById('app'));
}

if(document.getElementById('tab')) {
    ReactDOM.render(<Tabs />, document.getElementById('tab'));
}

